interface Conversation {
  id: string;
  created_at: string;
}

interface SidebarProps {
  conversations: Conversation[];
  currentConversationId: string | null;
  onConversationSelect: (id: string) => void;
  onNewChat: () => void;
}

export default function Sidebar({ conversations, currentConversationId, onConversationSelect, onNewChat }: SidebarProps) {
  return (
    <div className="w-64 bg-zinc-800/50 border-r border-white/10 h-[calc(100vh-64px)] flex flex-col">
      <div className="p-4">
        <button
          onClick={onNewChat}
          className="w-full bg-gradient-to-r from-orange-500 via-purple-600 to-pink-500 hover:from-orange-600 hover:via-purple-700 hover:to-pink-600 text-white px-4 py-2 rounded-lg transition-colors"
        >
          New Chat
        </button>
      </div>
      
      <div className="flex-1 overflow-y-auto p-2 space-y-2">
        {conversations.map((conversation) => (
          <button
            key={conversation.id}
            onClick={() => onConversationSelect(conversation.id)}
            className={`w-full text-left px-4 py-2 rounded-lg transition-colors ${
              currentConversationId === conversation.id
                ? 'bg-white/10 text-white'
                : 'text-white/60 hover:bg-white/5 hover:text-white'
            }`}
          >
            {new Date(conversation.created_at).toLocaleDateString()}
          </button>
        ))}
      </div>
    </div>
  );
} 